'use client';
import { jsx } from 'react/jsx-runtime';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
let c = renderWithRef('CarouselSlide', null, (r, o)=>{
    let { children: c, 'aria-roledescription': s } = r, l = _object_without_properties(r, [
        "children",
        'aria-roledescription'
    ]), a = useInternalOptionalSwanI18nContext(), u = s;
    return void 0 === s && a && (u = a.t('carousel-slide.aria-roledescription')), useDeprecatedProps('CarouselSlide', r, [
        {
            propName: 'aria-roledescription',
            instructions: getDeprecatedI18nPropMessage(a)
        }
    ]), jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-carousel-slide'
        ],
        props: _object_spread_props(_object_spread({
            role: 'group'
        }, l), {
            'aria-roledescription': u || 'slide'
        }),
        children: c
    });
});
const CarouselSlide = deprecatedComponent({
    description: 'Use AdaptiveCarousel instead',
    displayName: 'CarouselSlide',
    root: c
});

export { CarouselSlide };
